module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))])]), _c('div', {
    staticClass: "mb-5"
  }), _c('section'), _c('div', {
    staticClass: "mb-10"
  }), _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("我要報名")]), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_vm._v("報名進度確認")]), _c('div', {
    staticClass: "mb-6"
  }), _vm._m(1)], 1), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_vm._m(4), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tickets-info-wrap"
  }, [_c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("團體票")]), _c('div', {
    staticClass: "mb-5"
  }), _c('img', {
    attrs: {
      "src": require("assets/tickets-img/img-group-hover.png")
    }
  }), _c('div', {
    staticClass: "mb-3"
  }), _c('div', {
    staticClass: "price"
  }, [_vm._v("NT$2,500/席")]), _c('div', {
    staticClass: "description"
  }, [_vm._v("一次可報名 5~10 席")]), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'tickets'
      }
    }
  }, [_vm._v("前往購票")])], 1), _c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("團體潛水票")]), _c('div', {
    staticClass: "mb-5"
  }), _c('img', {
    attrs: {
      "src": require("assets/tickets-img/img-group-dive-hover.png")
    }
  }), _c('div', {
    staticClass: "mb-3"
  }), _c('div', {
    staticClass: "price"
  }, [_vm._v("NT$2,800/席")]), _c('div', {
    staticClass: "description"
  }, [_vm._v("一次可報名 5~10 席")]), _c('div', {
    staticClass: "btn ghost-btn",
    on: {
      "click": function($event) {
        _vm.explantion('潛水區')
      }
    }
  }, [_vm._v("潛水區 說明")])])]), _c('div', {
    staticClass: "mb-4"
  }), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'tickets'
      }
    }
  }, [_vm._v("前往購票頁面")]), _c('div', {
    staticClass: "mb-4"
  })], 1)]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_vm._m(5), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tickets-info-wrap"
  }, [_c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("個人票")]), _c('img', {
    attrs: {
      "src": require("assets/tickets-img/img-single-hover.png")
    }
  }), _c('div', {
    staticClass: "price"
  }, [_vm._v("NT$2,500/席")]), _c('div', {
    staticClass: "description"
  }, [_vm._v("一次可報名 1 席")]), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'tickets'
      }
    }
  }, [_vm._v("前往購票")])], 1), _c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("個人潛水票")]), _c('img', {
    attrs: {
      "src": require("assets/tickets-img/img-single-dive-hover.png")
    }
  }), _c('div', {
    staticClass: "price"
  }, [_vm._v("NT$2,800/席")]), _c('div', {
    staticClass: "description"
  }, [_vm._v("一次可報名 1 席")]), _c('div', {
    staticClass: "btn ghost-btn",
    on: {
      "click": function($event) {
        _vm.explantion('潛水區')
      }
    }
  }, [_vm._v("潛水區 說明")])])]), _c('div', {
    staticClass: "mb-4"
  }), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'tickets'
      }
    }
  }, [_vm._v("前往購票頁面")])], 1)]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_vm._m(6), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tickets-info-wrap"
  }, [_c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("身障票")]), _c('img', {
    attrs: {
      "src": require("assets/tickets-img/img-bodily-hover.png")
    }
  }), _c('div', {
    staticClass: "price"
  }, [_vm._v("NT$1,000/2席")]), _c('div', {
    staticClass: "description"
  }, [_vm._v("一次可報名 1~2 席")]), _c('div', {
    staticClass: "btn ghost-btn",
    on: {
      "click": function($event) {
        _vm.explantion('身障票')
      }
    }
  }, [_vm._v("身障票 說明")])])]), _c('div', {
    staticClass: "mb-4"
  }), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'tickets'
      }
    }
  }, [_vm._v("前往購票頁面")])], 1)]), _vm._m(7), _c('div', {
    staticClass: "mb-60"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("報名資格")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("1. 需為 4Gamers 會員 （需成為 4Gamers 會員並通過 Email 認證）")]), _c('li', [_c('div', {
    staticClass: "mb-3"
  }), _c('a', {
    staticClass: "btn ghost-btn",
    attrs: {
      "href": "https://www.4gamers.com.tw/member/player",
      "target": "_blank"
    }
  }, [_vm._v("檢視 Email 狀態")]), _c('div', {
    staticClass: "mb-3"
  })]), _c('li', [_vm._v("2. 於 2017 年 11 月 23 日 已年滿 18 歲")])]), _c('div', {
    staticClass: "steps-wrap"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("1")]), _c('div', {
    staticClass: "content"
  }, [_vm._v("呼朋引伴成為 4Gamers 會員")])]), _c('div', {
    staticClass: "step multiple",
    staticStyle: {
      "margin-bottom": "21px"
    }
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("2")]), _c('div', {
    staticClass: "content"
  }, [_vm._v("推舉團長進行"), _c('br'), _vm._v("團體早鳥票報名"), _c('br'), _c('small', [_vm._v("(請記得提供團長： 1. 4Gamers 帳號　2. 身份證後四碼)")])])]), _c('div', {
    staticClass: "step multiple"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("3")]), _c('div', {
    staticClass: "content"
  }, [_vm._v("審核通過收到"), _c('br'), _vm._v("FamiPort繳費代碼")])]), _c('div', {
    staticClass: "step multiple"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("4")]), _c('div', {
    staticClass: "content"
  }, [_vm._v("繳費完成"), _c('br'), _vm._v("可自行劃位")])]), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("5")]), _c('div', {
    staticClass: "content"
  }, [_vm._v("完成報名")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("報名須知")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("《BYOC進／撤場時間》")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("進場時間：11 月 23 日（四）12:00 － 20:00 及 11 月 24 日（五）12:00 － 20:00")]), _c('li', [_vm._v("撤場時間：11 月 26 日（日）16:00 － 18:00，主辦單位會在 17:30 開始撤場")]), _c('br'), _c('li', [_vm._v("進場報到時請出示個人身份證明文件與劃位票卷（Email或登入官網皆可）")])])])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("《BYOC 區進出規範》")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("1. BYOC 區僅限事先報名並完成報到手續的玩家及相關工作人員可進入。")]), _c('li', [_vm._v("2. BYOC 玩家於本活動期間可憑感應式識別手環全天候 24 小時進出 BYOC 區。")]), _c('li', [_vm._v("3. 需進出 BYOC 區域的相關工作人員需出示可通行 BYOC 的通行證才可入場。")])])])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("《 BYOC 注意事項》")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("1. 所有參加者須年滿 18 歲，入場時將以報名時所登錄的資訊為準，查驗參加者之身分證明文件，以確保每位參加者均合乎基本年齡限制。若遇資料不符者將無法入場，且不提供退費服務。")]), _c('li', [_vm._v("2. BYOC 區玩家進場時需攜帶電腦配備，包含電腦主機、筆電、家用電視遊戲主機等任一設備，不包含手機、平板電腦或掌上型遊戲主機，若違反此規則主辦單位有權取消資格且不提供退費服務。")]), _c('li', [_vm._v("3. 本活動所有銷售出之票券僅供個人娛樂之使用，活動現場歡迎任何創意佈置。範圍僅限個人桌面之寬度與深度，高度從地面算起不得超過 180 公分。")]), _c('li', [_vm._v("4. BYOC 參加者禁止於 BYOC 區及座位上進行非經官方許可的商業行為，如：商品展示、宣傳與販售（包含但不限於展示廠商的產品看板、DM、規格表等商業廣告資訊）。")]), _c('li', [_vm._v("5. 為保障參加者及參展廠商權益，並維護 BYOC 區進出管理規範，參加者設備不得由廠商提供並進場設置，還請自行攜帶相關設備進場。")]), _c('li', [_vm._v("6. 以上規範除已向主辦單位申請並取得同意之參加者外，若有違反者大會人員會依狀況要求即刻改善或取消參加資格。")]), _c('li', [_vm._v("7. 主辦單位保留活動之最後修改、解釋與中止權力。")]), _c('li', [_vm._v("8. 主辦單位僅負責進出場人員之控管，BYOC 參加者請務必留意自身所攜帶之設備及個人財物。")])])])]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("《 主辦單位 4Gamers 將提供每席 BYOC  項目 》")])]), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("1. 個人專屬感應式識別手環 x 1")]), _c('li', [_vm._v("2. 獨立個人空間（桌面寬度 90 公分、深度 60 公分、高度 75 公分）、椅子 x 1")]), _c('li', [_vm._v("3. 網路插座 x 1（須自備網路線）")]), _c('li', [_vm._v("4. 110 v 插座 x 1（須自備延長線材）")]), _c('li', [_vm._v("5. 生存包 x 1")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("報名階段與費用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("團體票：9 月 4 日起 － 10 月 31 日止")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("個人票：11 月 1 日起 － 11 月 10 日止")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("身障票：9 月 4 日起 － 11 月 10 日止")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("潛水區說明：該區域限定在 “D區” 。 WirForce 活動期間不會有廠商活動在該區進行。")])]), _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("身障票說明：＊一次可報名 2 席，需傳真身障證明方可報名，2 席座位將為隔壁，由大會安排在指定身障席。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c54df6be"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about.vue
// module id = 581
// module chunks = 1